import React, { useState, useEffect } from "react";
import { db } from "../../../../backend/firebaseConfig";
import { doc, onSnapshot } from "firebase/firestore";

// Default services list (fallback)
export const servicesList = [
  // BASIC SERVICES
  { name: "Oral Prophylaxis (Cleaning)", price: "₱1,000-3,000", category: "Basic Services", definition: "Thorough removal of plaque and tartar to maintain healthy gums and teeth." },
  { name: "Temporary Filling (pasta)", price: "₱900", category: "Basic Services", definition: "Quick solution to protect cavities before permanent treatment." },
  { name: "Permanent Filling", price: "₱1,000/surface", category: "Basic Services", definition: "Durable restoration for decayed teeth using high-quality materials." },
  { name: "Fluoride Treatment", price: "₱1,500", category: "Basic Services", definition: "Strengthens enamel and helps prevent tooth decay." },
  { name: "Consultation", price: "₱500", category: "Basic Services", definition: "Personalized dental assessment and treatment planning." },

  // DENTURE (POSTISO)
  { name: "Partial Denture (acrylic)", price: "starts at ₱5,000", category: "Denture", definition: "Affordable option to replace missing teeth with a removable acrylic base." },
  { name: "Partial Denture (flexible)", price: "₱10,000/quadrant", category: "Denture", definition: "Comfortable and aesthetic alternative using flexible materials." },
  { name: "Full Denture (acrylic)", price: "₱15,000/arch", category: "Denture", definition: "Complete set of acrylic dentures for full arch restoration." },
  { name: "Full Denture (high impact)", price: "₱25,000/arch", category: "Denture", definition: "Stronger acrylic dentures designed for long-term use." },
  { name: "Full Denture (DG-CRYL)", price: "₱25,000/arch", category: "Denture", definition: "Premium-grade denture offering enhanced durability and fit." },
  { name: "Reline (pahugot)", price: "₱2,500", category: "Denture Repair", definition: "Adjusts the fit of existing dentures for improved comfort." },
  { name: "Rebase (replace whole base sa postiso)", price: "₱4,000", category: "Denture Repair", definition: "Replaces the entire base of the denture for a fresh foundation." },

  // EXTRACTION & SURGERY
  { name: "Simple tooth extraction", price: "₱1,500/tooth", category: "Extraction & Surgery", definition: "Safe removal of teeth with minimal discomfort." },
  { name: "Complicated Extraction", price: "₱2,000-3,500/tooth", category: "Extraction & Surgery", definition: "Surgical removal of impacted or broken teeth." },
  { name: "Erupted Wisdom Tooth", price: "₱10,000-20,000/tooth", category: "Extraction & Surgery", definition: "Specialized extraction for fully emerged wisdom teeth." },
  { name: "Gingivectomy", price: "₱2,500/area, ₱10,000/arch", category: "Extraction & Surgery", definition: "Gum reshaping to treat periodontal issues or enhance aesthetics." },
  { name: "Operculectomy", price: "₱2,500-5,000", category: "Extraction & Surgery", definition: "Removal of gum tissue covering a partially erupted tooth." },

  // ORTHODONTICS (BRACES)
  { name: "Conventional/standard", price: "₱65,000-95,000", category: "Orthodontics", definition: "Traditional metal braces for effective alignment." },
  { name: "Conventional ceramic", price: "₱80,000", category: "Orthodontics", definition: "Tooth-colored brackets for a discreet look." },
  { name: "Self Ligating Braces", price: "₱90,000-95,000", category: "Orthodontics", definition: "Advanced braces with reduced friction and faster results." },
  { name: "Q Aligner (mild)", price: "₱170,000", category: "Orthodontics", definition: "Clear aligners tailored to the complexity of alignment needs." },
  { name: "Q Aligner (moderate)", price: "₱200,000", category: "Orthodontics", definition: "Clear aligners tailored to the complexity of alignment needs." },
  { name: "Q Aligner (severe)", price: "₱220,000", category: "Orthodontics", definition: "Clear aligners tailored to the complexity of alignment needs." },
  { name: "Bracket/Buccal Tube", price: "₱1,500", category: "Orthodontics", definition: "Quick fix for detached orthodontic components." },
  { name: "Replacement (recement)", price: "₱800", category: "Orthodontics", definition: "Reattaches loose brackets securely." },
  { name: "Replacement (bracket)", price: "₱500/bracket", category: "Orthodontics", definition: "Replaces damaged brackets individually." },
  { name: "Removal of brackets", price: "₱1,500/arch", category: "Orthodontics", definition: "Safe removal of braces after treatment completion." },

  // COSMETIC
  { name: "Composite Veneers", price: "₱4,500/tooth", category: "Cosmetic", definition: "Resin-based veneers for a natural and affordable smile enhancement." },
  { name: "Emax Veneer/Crown", price: "₱16,000/tooth", category: "Cosmetic", definition: "High-strength ceramic for lifelike aesthetics and durability." },
  { name: "Zirconia Veneer/Crown", price: "₱16,000/tooth", category: "Cosmetic", definition: "Premium restoration with superior strength and translucency." },
  { name: "Porcelain fused to metal", price: "₱10,000/tooth", category: "Cosmetic", definition: "Combines strength of metal with the beauty of porcelain." },
  { name: "Porcelain fused to zirconia", price: "₱16,000/tooth", category: "Cosmetic", definition: "Enhanced aesthetics with zirconia’s durability." },
  { name: "Acrylic Crown (plastic)", price: "₱6,000/tooth", category: "Cosmetic", definition: "Budget-friendly crown option for temporary use." },
  { name: "Cosmetic per side", price: "₱3,500/side",  definition: "Targeted cosmetic enhancements for specific areas.", category: "Cosmetic" },

  // RETAINER
  { name: "Essix", price: "₱6,500/arch", category: "Retainer", definition: "Clear, removable retainer for post-braces maintenance." },
  { name: "Hawley's", price: "₱6,500/arch", category: "Retainer", definition: "Classic wire-and-acrylic retainer for long-term stability." },
  { name: "Lingual Retainer", price: "₱6,500/arch", category: "Retainer", definition: "Fixed retainer placed behind teeth for invisible support." },

  // TMD TREATMENT
  { name: "EF", price: "₱30,000 (mild case)", category: "TMD Treatment", definition: "Fixed retainer placed behind teeth for invisible support." },
  { name: "SPLINT", price: "₱15,000", category: "TMD Treatment", definition: "Custom splint to relieve jaw tension and improve bite alignment." },
  { name: "Teeth Whitening", price: "₱12,000", category: "TMD Treatment", definition: "Brightens your smile safely with noticeable results in one session." },
];

const ServicesList = ({ 
  selectedServices, 
  toggleService, 
  showPrices = true, 
  isEditMode = false,
  servicePrices = {},
  onServicePriceChange = null,
  dentistUID = null, // Optional: if provided, load services for specific dentist
  allowServicePriceEdit = true, // When false, per-service price inputs are read-only (Appointment Details uses this for non-Completed status)
}) => {
  const [services, setServices] = useState(servicesList); // Use default as initial state

  // Load services from Firestore with real-time updates
  useEffect(() => {
    if (!dentistUID) {
      // If no dentistUID, use default services
      setServices(servicesList);
      return;
    }

    const servicesRef = doc(db, "services", dentistUID);
    
    // Set up real-time listener
    const unsubscribe = onSnapshot(
      servicesRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const firestoreServices = snapshot.data().servicesList;
          if (firestoreServices && firestoreServices.length > 0) {
            setServices(firestoreServices);
            return;
          }
        }
        // Fallback to default services if no services found
        setServices(servicesList);
      },
      (error) => {
        // Silently handle permission errors during sign-out
        if (error.code === 'permission-denied') {
          console.log('Services listener stopped due to sign-out');
          return;
        }
        console.error("Error loading services from Firestore:", error);
        // Keep using default services if there's an error
        setServices(servicesList);
      }
    );
    
    // Cleanup listener on unmount or when dentistUID changes
    return () => unsubscribe();
  }, [dentistUID]);

  // Group services by category
  const groupedServices = services.reduce((acc, service) => {
    if (!acc[service.category]) {
      acc[service.category] = [];
    }
    acc[service.category].push(service);
    return acc;
  }, {});

  return (
    <div style={{ border: "2px solid #C7A76C", padding: "16px", width: "100%", maxHeight: "400px", overflowY: "auto", overflowX: "hidden", borderRadius: "12px", backgroundColor: "white", boxSizing: "border-box" }}>
      {Object.entries(groupedServices).map(([category, categoryServices]) => (
        <div key={category} style={{ marginBottom: "20px" }}>
          <h4 style={{ margin: "0 0 12px 0", fontSize: "18px", fontWeight: "700", color: "#333", borderBottom: "2px solid #C7A76C", paddingBottom: "8px" }}>
            {category}
          </h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {categoryServices.map((service, index) => (
              <li
                key={index}
                onClick={() => toggleService(service.name)}
                style={{ 
                  cursor: "pointer", 
                  background: selectedServices.includes(service.name) ? "#e3f2fd" : "#fff", 
                  padding: "12px 8px", 
                  borderBottom: "1px solid #f0f0f0",
                  fontSize: "15px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderRadius: "6px",
                  marginBottom: "4px",
                  transition: "all 0.2s ease",
                  border: selectedServices.includes(service.name) ? "2px solid #C7A76C" : "1px solid transparent"
                }}
                onMouseEnter={(e) => {
                  if (!selectedServices.includes(service.name)) {
                    e.target.style.backgroundColor = "#f8f9fa";
                    e.target.style.borderColor = "#C7A76C";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!selectedServices.includes(service.name)) {
                    e.target.style.backgroundColor = "#fff";
                    e.target.style.borderColor = "transparent";
                  }
                }}
              >
                <span style={{ flex: 1, fontWeight: "500" }}>{service.name}</span>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  {showPrices && (
                    <span style={{ fontSize: "14px", color: "#C7A76C", fontWeight: "600" }}>
                      {service.price}
                    </span>
                  )}
                  {isEditMode && selectedServices.includes(service.name) && onServicePriceChange && (
                    <input
                      type="number"
                      min={0}
                      step={1}
                      inputMode="numeric"
                      placeholder="Price"
                      value={servicePrices[service.name] || ""}
                      onChange={(e) => onServicePriceChange(service.name, e.target.value)}
                      onKeyDown={(e) => {
                        if (!allowServicePriceEdit) return;
                        if (["e", "E", "+", "-", "."].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        if (!allowServicePriceEdit) return;
                        const text = (e.clipboardData.getData("text") || "").trim();
                        e.preventDefault();
                        if (text === "") {
                          onServicePriceChange(service.name, "");
                          return;
                        }
                        if (!/^\d+$/.test(text)) return;
                        onServicePriceChange(service.name, text);
                      }}
                      onClick={(e) => e.stopPropagation()}
                      disabled={!allowServicePriceEdit}
                      readOnly={!allowServicePriceEdit}
                      title={!allowServicePriceEdit ? "Prices can only be edited when the appointment status is Completed" : undefined}
                      style={{
                        width: "100px",
                        padding: "6px 8px",
                        fontSize: "14px",
                        border: "2px solid #C7A76C",
                        borderRadius: "6px",
                        backgroundColor: allowServicePriceEdit ? "white" : "#f5f5f5",
                        cursor: allowServicePriceEdit ? "text" : "not-allowed",
                        opacity: allowServicePriceEdit ? 1 : 0.75
                      }}
                    />
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default ServicesList;